import { render, staticRenderFns } from "./ContactAddress.vue?vue&type=template&id=0c71530a&scoped=true"
import script from "./ContactAddress.vue?vue&type=script&lang=js"
export * from "./ContactAddress.vue?vue&type=script&lang=js"
import style0 from "./ContactAddress.vue?vue&type=style&index=0&id=0c71530a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c71530a",
  null
  
)

export default component.exports